import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const limit = 10;
const compact = new Intl.NumberFormat("en", { notation: "compact" });
const truncateLabel = (v) => (v && v.length > 12 ? `${v.slice(0, 12)}…` : v);

const PaymentsBySourceChart = ({ data }) => {
    const chartData = [...data].sort((a, b) => b.payments - a.payments).slice(0, limit);

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-violet-50/40 to-white p-5">
            <h2 className="text-sm font-semibold text-slate-900">Top {limit} Payment Sources</h2>
            <p className="mb-3 text-xs text-slate-500">Ranked by successful payments</p>

            <ResponsiveContainer width="100%" height={260}>
                <BarChart data={chartData} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F3E8FF" />
                    <XAxis
                        dataKey="source"
                        interval={0}
                        angle={-25}
                        textAnchor="end"
                        height={55}
                        tick={{ fontSize: 11 }}
                        tickFormatter={truncateLabel}
                    />
                    <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => compact.format(v)} width={36} />
                    <Tooltip
                        cursor={{ fill: "#F5F3FF" }}
                        formatter={(value) => [compact.format(value), "Payments"]}
                        contentStyle={{ borderRadius: 10, border: "1px solid #E2E8F0", fontSize: 12 }}
                    />
                    <Bar dataKey="payments" fill="#8B5CF6" radius={[6, 6, 0, 0]} maxBarSize={36} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PaymentsBySourceChart;